import React from 'react'
import PropTypes from 'prop-types'
import Button, { TYPES } from '../../Button/index'
import CommentIcon from '../../Icon/icons/Comment/index'

/**
 * @param {Object} props - The props
 * @param {Number} props.commentCount - The number of comments
 * @param {String} props.url - The url to the comments section
 * @param {Function} props.onClick - The function to call when the comments button is clicked
 * @returns {JSX.Element} DetailPageV3ActionComments
 */

const DetailPageV3ActionComments = (props) => {
  const {
    commentCount = 0,
    url,
    onClick,
  } = props

  const handleCommentsClick = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <Button
      url={url}
      type={TYPES.ICON}
      iconSvg={<CommentIcon size={28} />}
      onClick={handleCommentsClick}
      className="detail-page-v3__action-button"
    >
      <span className="detail-page-v3__action-label">
        {commentCount}
      </span>
    </Button>
  )
}

DetailPageV3ActionComments.propTypes = {
  commentCount: PropTypes.number,
  url: PropTypes.string,
  onClick: PropTypes.func,
}

export default DetailPageV3ActionComments
